var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-message-markdown"},[_c('vue-markdown',{attrs:{"source":_vm.message.markdown,"id":_vm.message.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }